import styled from '@emotion/styled'
import { useState } from 'react'
import { MdVolumeDown, MdVolumeOff, MdVolumeUp } from 'react-icons/md'
import { useDispatch, useSelector } from 'react-redux'
import { setVolume } from '../../redux/actions'
import Icon from '../Icon'
import Slider from '../Slider'

const Container = styled.div`
  align-items: center;
  display: flex;
`

const StyledSlider = styled(Slider)`
  width: 75%;
`

const IconComponent = ({ onClick, volume }) => {
  if (volume == 0) {
    return <MdVolumeOff onClick={onClick} />
  } else if (volume < 0.5) {
    return <MdVolumeDown onClick={onClick} />
  } else {
    return <MdVolumeUp onClick={onClick} />
  }
}

const Volume = ({ className }) => {
  const dispatch = useDispatch()
  const volume = useSelector((state) => state.player.volume)
  const [muted, setMuted] = useState(false)
  const [prevVolume, setPrevVolume] = useState(0.8)

  const onChange = (e) => {
    dispatch(setVolume(e.target.value))
  }

  const onVolumeClick = () => {
    if (muted) {
      dispatch(setVolume(prevVolume))
      setMuted(false)
    } else {
      setPrevVolume(volume)
      setMuted(true)
      dispatch(setVolume(0))
    }
  }

  return (
    <Container className={className}>
      <Icon className="mr1" size="1em">
        <IconComponent onClick={onVolumeClick} volume={volume} />
      </Icon>
      <StyledSlider
        id="myRange"
        max="1"
        min="0"
        onChange={onChange}
        step="0.05"
        type="range"
        value={volume}
      />
    </Container>
  )
}

export default Volume
